module.exports = __webpack_public_path__ + "img/Decision.a5ee3b9f.svg";